import React, { useEffect, useState } from "react";
import styled from "styled-components";
import Button from "../../components/common/Button";
import { RotatingLines } from "react-loader-spinner";
import Body from "../../components/common/Body";
import { useLocation, useNavigate, useParams } from "react-router-dom";
import { useDispatch } from "react-redux";
import InputFileV2 from "../../components/common/InputFileV2";
import { useFulfillModifyMutation, useFulfillRegisterMutation, useGetFulfillDataMutation } from "../../api/noticeAPI";
import TextareaV2 from "../../components/common/TextareaV2";
import { setToggleData } from "../../store/reducers/toggleReduce";
import { checkDeleteImage } from "../../utils/noticeUtil";

const FulfillRegister = () => {
  const [imageList, setImageList] = useState<(File | Image)[]>([]);
  const [tempImageList, setTempImageList] = useState<Image[]>([]);
  const [contents, setContents] = useState("");
  const noticeId = useParams().fulfill_id;
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const modifyMode: boolean | undefined = (useLocation() as any).state?.modify;
  const fulfillId: string | undefined = (useLocation() as any).state?.fulfillId;
  const [fullfillRegister] = useFulfillRegisterMutation();
  const [fulfillModify] = useFulfillModifyMutation();
  const [getFulfill] = useGetFulfillDataMutation();
  const [sending, setSending] = useState(false);
  async function getModfiyData() {
    const response: any = await getFulfill(fulfillId);
    const temp: FulfillModifyApi = response.data;
    setImageList(temp.images);
    setTempImageList(temp.images);
    setContents(temp.execute_contents);
  }

  useEffect(() => {
    modifyMode && fulfillId && getModfiyData();
  }, [modifyMode && fulfillId]);

  async function register(imageList: (File | Image)[]) {
    try {
      if (contents == "") {
        alert("내용을 입력해 주세요.");
        return;
      }
      if (imageList.length < 1) {
        alert("이행 사진을 첨부해주세요.");
        return;
      }
      setSending(true);
      dispatch(setToggleData({ mode: "SENDING", data: "이행 등록중입니다." }));
      const form = new FormData();
      form.append("execute_contents", contents);
      imageList.forEach((image) => form.append("images", image as File));
      const response: any = await fullfillRegister({ fullfillIdx: noticeId, data: form });
      if (response?.data?.message === "success") {
        dispatch(setToggleData({ mode: "SUCCESS", data: "이행 등록 완료." }));
        back();
      } else {
        const errorMessage = response?.error?.data?.message;
        errorMessage && alert(errorMessage);
        dispatch(setToggleData({ mode: "ERROR", data: "이행 등록 실패." }));
        setSending(false);
      }
    } catch (e: any) {
      dispatch(setToggleData({ mode: "ERROR", data: "이행 등록 실패." }));
      setSending(false);
      console.error(e);
    }
  }
  async function modifyRegister(imageList: (File | Image)[]) {
    try {
      if (contents == "") {
        alert("내용을 입력해 주세요.");
        return;
      }
      if (imageList.length < 1) {
        alert("이행 사진을 첨부해주세요.");
        return;
      }
      setSending(true);
      dispatch(setToggleData({ mode: "SENDING", data: "이행 수정중입니다." }));
      const form = new FormData();
      form.append("execute_contents", contents);
      const addImageList = imageList.filter((image) => (image as File).name !== undefined);
      addImageList.forEach((image) => form.append("images", image as File));
      const deleteImageList = checkDeleteImage(tempImageList, imageList);
      deleteImageList.forEach((image, index) => form.append(`delete_imgs[${index}]`, image));
      const response: any = await fulfillModify({ fullfillIdx: noticeId, data: form });

      if (response?.data?.message === "success") {
        dispatch(setToggleData({ mode: "SUCCESS", data: "이행 수정 완료." }));
        back();
      } else {
        const errorMessage = response?.error?.data?.message;
        errorMessage && alert(errorMessage);
        dispatch(setToggleData({ mode: "SUCCESS", data: "이행 수정 완료." }));
        setSending(false);
      }
    } catch (e) {
      dispatch(setToggleData({ mode: "ERROR", data: "이행 수정 실패." }));
      setSending(false);
      console.error(e);
    }
  }

  function back() {
    navigate(-1);
  }

  return (
    <>
      <header>
        <div>
          <Button variant="text" className="btn-back" onClick={() => back()}>
            이행 등록
          </Button>
        </div>
        <div className="btn-box">
          {sending ? (
            <p style={{ textAlign: "center" }}>
              <RotatingLines width="20" strokeColor="#00263e" strokeWidth="1" />
            </p>
          ) : (
            <Button variant="text" onClick={modifyMode ? () => modifyRegister(imageList) : () => register(imageList)}>
              {modifyMode ? "수정" : "등록"}
            </Button>
          )}
        </div>
      </header>
      <Body type="detail">
        <WriteWrap>
          <InputFileV2 className="input-file" imageList={imageList} setImageList={setImageList} accept={"image/*"} />
          <TextareaV2 className="textarea-wrap" text={contents} id="contents" placeholder="이행 건에 대해 자세히 설명해주세요!" onChange={setContents} />
        </WriteWrap>
      </Body>
    </>
  );
};

const WriteWrap = styled.div`
  height: calc(100% - 60px);
  padding: 0 15px 30px;
`;

export default FulfillRegister;
